import clsx from 'clsx';
import { usePDPState } from '~/features/product-details/context';
import { SalesforceProduct } from '~/lib/salesforce/types';
import {
    ProductSplash as BaseProductSplash,
    ProductSplashProps as BaseProductSplashProps,
} from '~/shared/components/ProductSplash';
import styles from './ProductSplash.module.scss';

type Props = Omit<BaseProductSplashProps, 'id' | 'splash' | 'specialPrices'> & {
    product: SalesforceProduct;
};

/** Binds the shared splash to a product, so callers pass the product rather than three fields. */
export const ProductSplash: React.FC<Props> = ({ className, product, ...rest }) => {
    const { isPromotionDiscountHeldBack } = usePDPState();
    const splashText = product.c_splash;

    // The splash advertises a discount that does not apply until the countdown ends.
    if (isPromotionDiscountHeldBack) return null;

    return (
        <BaseProductSplash
            id={product.id}
            className={clsx(styles.productSplash, className)}
            background="white"
            {...rest}
            specialPrices={product.c_specialPrices}
            splash={{ text: splashText }}
        />
    );
};
